import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-delete-credits',
  templateUrl: './delete-credits.modal.html'
})
export class DeleteCreditsModal implements OnInit {

  creditGuid!: string;

  constructor(private activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    // Must not be empty. It's approved by a comment.
  }

  close() {
    this.activeModal.close(false);
  }

  delete() {
    this.activeModal.close(this.creditGuid);
  }

}
